import { DiscountType } from "@/constants/discountType";

export const formatDiscount = (
  value: number,
  type?: DiscountType | string,
): string => {
  if (type == "percentage") {
    return `${value}%`;
  }

  // format to MGA
  return new Intl.NumberFormat("fr-MG", {
    style: "currency",
    currency: "MGA",
    minimumFractionDigits: 0,
  })
    .format(value)
    .replace(/\s?Ar$/, " Coins");
};
